<template>
	<div class="index">
		<!-- banner图 -->
		<div class="newsCenterBanenr">
			<img src="../../assets/xiangning/ztpx/ztpx_banner.png">
		</div>
		<div class="djxxhome_wrap">
			<!-- 新闻中心上方标题栏 -->
			<div class="news_title">
				<div class="title_left">
					<img src="../../assets/xiangning/home/titile_left.png" alt="">
				</div>
				<div class="news_title_left">
					<div @click="changeType(1)" class="news_title_left_text"
						:style="{ color: getdata.type == 1 ? '#D31813' : '#999999', fontWeight: getdata.type == 1 ? '800' : '400' }">集体培训
					</div>
					<div @click="changeType(2)" class="news_title_left_text"
						:style="{ color: getdata.type == 2 ? '#D31813' : '#999999', fontWeight: getdata.type == 2 ? '800' : '400' }">党员培训
					</div>

				</div>
				<div class="right_back">
					<div class="right_back_icon"><img src="../../assets/xiangning/newsCenter/back.png" alt=""></div>
					<div>返回</div>
				</div>
			</div>
			<!-- 视频列表 -->
			<div class="dataList" v-if="dataList.length > 0">
				<!-- 遍历列表循环 -->
				<div class="dataList_item" v-for="item in dataList" :key="item.id" @click="goDjxxDetail(item.id)">
					<div class="dataList_item_top_img">
						<img :src="item.sz_img" alt="">
					</div>
					<div class="dataList_item_bottom">
						<!-- 上方标题 -->
						<div class="dataList_item_bottom_top_title">{{ item.title }}</div>
						<!-- 下方课程信息 -->
						<div class="dataList_item_bottom_botom">
							<div class="dataList_item_bottom_botom_item">
								<div class="dataList_item_bottom_botom_item_icon">
									<img src="../../assets/xiangning/djxx/icon_1.png" alt="">
								</div>
								<div class="dataList_item_bottom_botom_item_content">
									共{{ item.count }}课
								</div>
							</div>
							<div class="dataList_item_bottom_botom_item">
								<div class="dataList_item_bottom_botom_item_icon">
									<img src="../../assets/xiangning/djxx/icon_3.png" alt="">
								</div>
								<div class="dataList_item_bottom_botom_item_content">
									{{ item.hours.substring(0, 3) }}课时
								</div>
							</div>
							<div class="dataList_item_bottom_botom_item">
								<div class="dataList_item_bottom_botom_item_icon">
									<img src="../../assets/xiangning/djxx/icon_2.png" alt="">
								</div>
								<div class="dataList_item_bottom_botom_item_content">
									{{ item.nums }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--  -->
			<!-- 下方分页器 -->
			<Page v-if="dataList.length > 0" :total="total" :per_page="per_page" :pageSize="[20]"
				@handleCurrentChange="handleCurrentChange">
			</Page>
			<!-- 资源为空时显示 -->
			<div v-if="dataList.length == 0" class="no_pxrw">
				<img src="../../assets/xiangning/ztpx/no_pxrw.png" alt="">
			</div>

			<div style="height: 40px;" class="bottom"></div>
		</div>

	</div>
</template>
<script>
import Swiper from 'swiper';
import { ztpx } from '@/axios';
import Page from '@/components/page.vue'
export default {
	name:'ztpx',
	data() {
		return {
			// 总数据条数
			total: 100,
			// 当前页码
			per_page: 1,
			input: '',
			getdata: {
				uid: this.$store.state.user.userinfo2.id,
				flag: this.$store.state.user.userinfo2.flag,
				type: 1,
				page: 1,
				keys: ''
			},
			dataList: []
		}
	},
	components: { Page },
	methods: {
		//   分页器页码发生变化
		handleCurrentChange() { },
		goHome() {
			this.$router.push({
				path: '/home'
			})
		},
		changeType(val) {
			this.getdata.type = val
			this.getdata.page = 1
			this.getZtpxList()

		},
		// 点击关键字
		getKeys(val) {
			this.getdata.keys = val
		},
		// 跳转至专题培训详情
		goDjxxDetail(id) {
		
			this.$router.push({
				path: "/ztpxDetail",
				query: {
					tid: id
				}
			})
		},
		getZtpxList() {
			let that = this
			ztpx.ztpxList(that.getdata).then((res) => {
				if (res.code == 200) {
				
					that.total = res.data.count
					if (res.data.pagedata) {
						that.dataList = res.data.pagedata
					}else{
						that.dataList=[]
					}
					
				}
			})
		}
	},
	mounted() {
		this.getZtpxList()
	},
	created() {
		this.$emit("highLight", 3, "", "", "");
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/index.scss';

.index {
	.right_back {
		display: flex;
		font-family: PingFangSC-Regular;
		font-size: 12px;
		font-weight: normal;
		letter-spacing: 0em;
		color: #666666;
		margin-right: 10px;
		width: 50px;
	}

	.right_back:hover {
		font-weight: 800;
		color: #EE632B;
	}

	.right_back_icon {
		height: 10px;
		width: 12px;
		margin-right: 5px;
	}

	.right_back_icon img {
		height: 100%;
		width: 100%;
	}

	width: 100%;

	.newsCenterBanenr {
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
		}
	}

	div {
		box-sizing: border-box;
	}

	.djxxhome_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;
		position: relative;

		/* 搜索框部分 */
		.search {
			position: absolute;
			top: -127px;
			width: 100%;
			height: 107px;
			/* background-color: skyblue; */
			display: flex;
			justify-content: center;

			.search_item {
				height: 77px;
				width: 600px;
				position: relative;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;

				/* background-color: pink; */
				input {
					display: block;
					background-color: #FCEAE4;
					background: rgba(255, 255, 255, 0.8);
					border-radius: 304px;
					height: 40px;
					width: 100%;
					box-sizing: border-box;
					border: 1px solid #FFFFFF;
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0.1em;
					padding-left: 20px;
					color: #9E9E9E;
					outline: none;
				}

				.search_item_buttom {
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					right: 1px;
					top: 1px;
					height: 38px;
					width: 120px;
					background-color: #EE632B;
					border-radius: 0px 20px 20px 0px;

					.search_item_buttom_icon {
						margin-right: 12px;
						width: 24px;
						height: 20px;

						img {
							height: 100%;
							width: 100%;
						}
					}

					.search_text {
						font-family: PingFangSC-Regular;
						font-size: 16px;
						font-weight: normal;
						letter-spacing: 0em;
						color: #FFFFFF;
						height: 32px;
						line-height: 32px;
					}

				}

				.bottom_keys {
					// width: 100%;
					height: 17px;
					/* background-color: pink; */
					width: 450px;
					display: flex;
					justify-content: space-around;
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;

					color: #FFFFFF;
				}
			}
		}

		// 上方筛选标题
		.swiper {
			position: relative;
			width: 100%;
			height: 165px !important;
			margin-left: auto;
			margin-right: auto;
			margin-top: 20px;
			/* position: absolute; */
			/* margin-bottom: 20px; */
			overflow: hidden;

			.swiper-wrapper {
				.swiper-slide {
					text-align: center;
					font-size: 18px;
					height: 60px !important;
					/* Center slide text vertically */
					display: -webkit-box;
					display: -ms-flexbox;
					display: -webkit-flex;
					display: flex;
					-webkit-box-pack: center;
					-ms-flex-pack: center;
					-webkit-justify-content: center;
					justify-content: center;
					-webkit-box-align: center;
					-ms-flex-align: center;
					-webkit-align-items: center;
					align-items: center;

					box-sizing: border-box;
					overflow: hidden;
					width: 224px;
					height: 60px;
					/* margin-right: 20px; */
					border-top: 4px solid #CD050E;
					background-color: #F6F6F6;
					/* margin-right: 20px; */
					/* margin-top: 20px; */
					justify-content: center;
					align-items: center;
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					line-height: 22px;
					text-align: center;
					letter-spacing: 0px;

					/* color: #000000; */
					.select_title_item_text {
						box-sizing: border-box;
						width: 200px;
						font-family: PingFangSC-Regular;
						font-size: 14px;
						font-weight: normal;
						text-align: center;
						letter-spacing: 0px;
						/* color: #000000; */
						text-overflow: -o-ellipsis-lastline;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;

					}

				}

				.select_title_item_select {
					background-image: url('../../assets/xiangning/djxx/hover_img.png');
					background-size: cover;
					color: #FFFFFF;
				}

				.swiper-slide:hover {
					background-image: url('../../assets/xiangning/djxx/hover_img.png');
					background-size: cover;
					color: #FFFFFF;

					.select_title_item_text {
						color: #FFFFFF;
					}
				}

			}

			.swiper-pagination {
				position: absolute;
				top: -5px;
				left: 0px;

				.my-bullet-active {
					background: #CD050E;
					opacity: 1;
				}

				.swiper-pagination-bullet {
					/* display: block; */
					width: 32px !important;
					height: 2px !important;
					background: #CD050E;
				}
			}
		}

		/* 标题部分样式 */
		.news_title {
			height: 32px;
			width: 100%;
			margin: 20px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-left: 32px;
			background: #FFF6F1;
			box-sizing: border-box;
			position: relative;

			.title_left {
				position: absolute;
				top: -5px;
				left: 0;
				height: 42px;
				width: 42px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.news_title_left {
			height: 22px;
			display: flex;
			justify-content: space-between;

		}

		.news_title_left_text {
			height: 22px;
			// width: 80px;
			padding: 0 20px;
			font-family: PingFangSC-Regular;
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 0.1em;
			color: #999999;
		}

		/* 视频列表 */
		.dataList {
			width: 100%;
			/* height: 610px; */
			margin-top: 20px;
			display: flex;
			flex-wrap: wrap;
			justify-content: start;
			align-content: start;
			overflow: hidden;

			.dataList_item {
				width: 224px;
				height: 190px;
				margin-bottom: 20px;
				margin-right: 20px;

				.dataList_item_top_img {
					height: 126px;
					width: 224px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.dataList_item_bottom {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					width: 100%;
					height: 64px;
					border: 1px solid #ECEEF4;
					padding: 10px;

					.dataList_item_bottom_top_title {
						width: 100%;
						height: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						font-family: PingFangSC-Medium;
						font-size: 14px;
						font-weight: 800;
						line-height: 20px;
						color: #000000;
					}

					.dataList_item_bottom_top_title:hover {
						color: #C9010A;
					}

					.dataList_item_bottom_botom {
						height: 16px;
						width: 100%;
						display: flex;

						.dataList_item_bottom_botom_item {
							overflow: hidden;
							height: 100%;
							width: 74px;
							display: flex;
							justify-content: center;

							.dataList_item_bottom_botom_item_icon {
								height: 12px;
								width: 12px;
								margin-right: 2px;
								position: relative;

								img {
									position: absolute;
									top: 2.5px;
									height: 100%;
									width: 100%;
								}
							}

							.dataList_item_bottom_botom_item_content {
								font-family: PingFangSC-Regular;
								font-size: 12px;
								font-weight: normal;
								letter-spacing: 0em;

								color: #999999;
							}
						}

						.dataList_item_bottom_botom_item:nth-child(2) {
							border-left: 1px solid #ECEEF4;
							border-right: 1px solid #ECEEF4;
							;
						}

						.dataList_item_bottom_botom_item:nth-child(1) {
							display: flex;
							justify-content: start;
						}

						.dataList_item_bottom_botom_item:nth-child(3) {
							display: flex;
							justify-content: end;

							.dataList_item_bottom_botom_item_icon {
								height: 10px;
								width: 15px;
							}
						}
					}
				}


			}

			.dataList_item:nth-child(5n) {
				margin-right: 0;

			}
		}

		// 无视频时显示
		.no_pxrw {
			width: 392px;
			height: 250px;
			margin: 124px auto;

			img {
				width: 100%;
				height: 100%;
			}
		}



	}
}</style>
